import React, { useContext, useState } from "react";
import {
    BrowserRouter as Routers,
    Route,
    Routes,
    Navigate
} from "react-router-dom";

import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import CreateAccount from "./pages/CreateAccount";
import { AuthProvider, AuthContext } from "./Contexts/auth";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";
import Configuration from "./pages/Configuration";
import NoScreensAllowed from "pages/NoScreensAllowed/NoScreensAllowed";
import { ChatbotProvider } from "./Contexts/ChatbotContext";
import ServiceItem from "pages/ServiceItem/ServiceOrder";

const AppRoutes = () => {
    const Private = ({ children }) => {

        const { authenticated, loading } = useContext(AuthContext);

        if (authenticated === false) {
            return <Navigate to="/login" />;
        }

        if (loading) {
            return (
                <div className="loading">
                    <LoadingIndicator loaded={false} colorSpinner={'#ffffff'} />
                </div>
            );
        }

        return children;
    };

    return (
        <Routers>
            <AuthProvider>
                <ChatbotProvider>
                    <Routes>
                        <Route exact path="/" element={<Login />} />
                        <Route exact path="/login" element={<Login />} />
                        <Route exact path="/forgot-password" element={<ChangePassword />} />
                        <Route exact path="/create-account" element={<CreateAccount />} />
                        <Route exact path="/no-screens-allowed" element={<Private><NoScreensAllowed /></Private>} />
                        <Route exact path="/configuration" element={<Configuration />} />
                        <Route exact path="/services" element={<ServiceItem />} />
                    </Routes>
                </ChatbotProvider>
            </AuthProvider>
        </Routers>
    )
}

export default AppRoutes;
